import TitleIcon from "@material-ui/icons/Title"
import type { LatLng, Map as LeafletMap, LeafletMouseEvent } from "leaflet"
import { useEffect, useMemo } from "react"
import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"
import { useMap } from "react-leaflet"
import { connect } from "react-redux"
import { MapViewerPanel, mapViewerSwitchEditPanel, mapViewerTogglePanel, projectAddDrawing } from "../../../redux"
import type {
  AppState,
  AppThunkDispatch,
  IMapDrawing,
  ITextMapDrawing,
  MapViewerActions,
  ProjectActions
} from "../../../redux"
import { createNewDrawingId } from "../../../utils"
import { TooltipIconButton } from "../../atoms"

export interface IDrawTextControlOwnProps {
  disabled: boolean
}

export interface IDrawTextControlStateProps {
  enabled: boolean
  toggleTyping: (open: boolean) => void
  selectControl: () => void
  addDrawing: (drawing: IMapDrawing) => void
  enableSelectionTool: () => void
}

function DrawTextControlView(props: IDrawTextControlOwnProps & IDrawTextControlStateProps): ReactElement {
  const { enabled, disabled, toggleTyping, selectControl, addDrawing, enableSelectionTool } = props
  const { t } = useTranslation("map")

  const map: LeafletMap = useMap()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const tooltipText: string = useMemo<string>(() => {
    return disabled ? t("actionButtons.edit.text.unavailableService") : t("actionButtons.edit.text.textTitle")
  }, [disabled])
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    map.on("click", selectLocation)

    return () => {
      map.off("click", selectLocation)
    }
  }, [enabled])

  function selectLocation(event: LeafletMouseEvent): void {
    if (!enabled) return
    map.off("click", selectLocation)

    const position: LatLng = event.latlng
    const textDrawing: ITextMapDrawing = {
      id: createNewDrawingId(),
      isPopupOpen: true,
      shape: {
        color: "#000000",
        finished: false,
        fontSize: 28,
        lineWidth: 4,
        position,
        text: t("actionButtons.edit.text.textTitle"),
        type: "text"
      }
    }
    addDrawing(textDrawing)
    enableSelectionTool()
  }

  function handleClick(): void {
    if (enabled) {
      toggleTyping(false)
    } else {
      selectControl()
    }
  }

  return (
    <TooltipIconButton
      onClick={handleClick}
      selected={enabled}
      placement="right"
      disabled={disabled}
      tooltip={tooltipText}
      icon={<TitleIcon />}
    />
  )
}

function mapStateToProps(state: AppState) {
  return {
    enabled: state.mapViewer.panels.get(MapViewerPanel.DrawText) || false
  }
}

function mapDispatchToProps(dispatch: AppThunkDispatch<ProjectActions | MapViewerActions>) {
  return {
    toggleTyping: (open: boolean) => dispatch(mapViewerTogglePanel(MapViewerPanel.DrawText, open)),
    selectControl: () => dispatch(mapViewerSwitchEditPanel(MapViewerPanel.DrawText)),
    enableSelectionTool: () => dispatch(mapViewerSwitchEditPanel(MapViewerPanel.Selection)),
    addDrawing: (drawing: IMapDrawing) => dispatch(projectAddDrawing(drawing))
  }
}

export const DrawTextControl = connect(mapStateToProps, mapDispatchToProps)(DrawTextControlView)
